export default () => ({
  user: null,
});
